import TablaServidor from '../../components/tabla/TablaServidor';
import { useTituloCabecera } from '../../context/tituloCabeceraContext';
import { COLUMNAS_RECIBOS, TABLA_RECIBOS } from '../../components/recibos/columnasRecibos';

const ListadoRecibos = () => {
  useTituloCabecera('Recibos', 'Gestiona y busca recibos del sistema');
  return (
    <TablaServidor
      tablaKey={TABLA_RECIBOS}
      columnas={COLUMNAS_RECIBOS}
      ruta="listado-recibos"
      archivo="recibos"
      nombreEntidad="recibos"
      placeholder="Buscar por nº de recibo, cliente, concepto o referencia…"
      claveFila={(f) => `${f.empresaId}-${f.recibo}`}
      tituloTarjeta={(f) => `#${f.recibo} · ${f.nombre || ''}`.trim()}
    />
  );
};

export default ListadoRecibos;
